import Auth from '../modules/Authentication'
import {handleErrors, handleResponse} from '../modules/Utils'
import {apiUrl, streamUrl} from '../variables/index'

const headers = {}

export default class Files {
  auth = new Auth()
  list = folder => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}files/?folder=${folder}`, {
      headers,
      method: 'GET',
    })
      .then(handleErrors)
      .then(handleResponse)
  }

  listMulti = folder => {
    const folders = Array.isArray(folder) ? folder.map(f => f._id) : folder._id
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}files/?folder=${folders}`, {
      headers,
      method: 'GET',
    })
      .then(handleErrors)
      .then(handleResponse)
  }

  upload = formData => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${streamUrl}files/`, {
      headers,
      method: 'POST',
      body: formData,
    })
      .then(handleErrors)
      .then(handleResponse)
  }

  uploadBulk = formData => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${streamUrl}files/bulk`, {
      headers,
      method: 'POST',
      body: formData,
    })
      .then(handleErrors)
      .then(handleResponse)
  }

  uploadRevision = (key, formData) => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${streamUrl}files/${key}/revision`, {
      headers,
      method: 'POST',
      body: formData,
    }).then(handleErrors)
    // .then(handleResponse)
  }

  update = data => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}files/`, {
      headers: headers,
      method: 'PATCH',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  }
  remove = data => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}files/`, {
      headers: headers,
      method: 'DELETE',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  }
  post = {
    upload: formData => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${streamUrl}files/posts`, {
        headers,
        method: 'POST',
        body: formData,
      })
        .then(handleErrors)
        .then(handleResponse)
    },
  }
}
